export const queryString = (query) =>
    query
        .filter(([, value]) => value !== undefined)
        .map((part) => part.map(encodeURIComponent))
        .map((part) => part.join('='))
        .join('&')
